var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"haulage-capacity-main"},[_c('Gantt',{staticClass:"capacity-gantt",attrs:{"dataFromServer":_vm.dataFromServer}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }